export function formatString(inputStr, params) {
    var outputStr = inputStr;
    Object.entries(params).forEach(function (_a) {
        var key = _a[0], value = _a[1];
        outputStr = outputStr.replace("{" + key + "}", value);
    });
    return outputStr;
}
